import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDHostPlayer implements ICommand
{

	public HostID : number = 0;
	public PlayerCount : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.HostID = ba.readUint16();
		this.PlayerCount = ba.readUint32();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint16(this.HostID);
		ba.writeUint32(this.PlayerCount);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDHostPlayer();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'HostID(W)='+this.HostID+' ';
		str += 'PlayerCount(D)='+this.PlayerCount+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 0;
	}

	public getCmdName() : string
	{
		return 'HostPlayer';
	}

}
